import { render, staticRenderFns } from "./SalesLeadQuotaDetails.vue?vue&type=template&id=83b85fa4&scoped=true&"
import script from "./SalesLeadQuotaDetails.vue?vue&type=script&lang=js&"
export * from "./SalesLeadQuotaDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeadQuotaDetails.vue?vue&type=style&index=0&id=83b85fa4&prod&lang=scss&scoped=true&"
import style1 from "./SalesLeadQuotaDetails.vue?vue&type=style&index=1&id=83b85fa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b85fa4",
  null
  
)

export default component.exports